import React, { useState } from "react";
import BlueImage from "../../assets/images/blue.jpeg";
const ArrayVideo = [
  {
    id: 1,
    title: "المقدمة",
    key: "r2T2ZHXB_bQ",
  },
  {
    id: 2,
    title: "المقدمة",
    key: "gxzkhowaVG0",
  },
  {
    id: 3,
    title: "المقدمة",
    key: "kFcv2Sb0XZU",
  },
  {
    id: 4,
    title: "المقدمة",
    key: "hmqp76HkjHA",
  },
  {
    id: 5,
    title: "المقدمة",
    key: "yN_zZKiH3_o",
  },
  {
    id: 6,
    title: "المقدمة",
    key: "Q_h8NB3Og28",
  },
  {
    id: 7,
    title: "المقدمة",
    key: "bYr7RPAAKQw",
  },
  {
    id: 8,
    title: "المقدمة",
    key: "nLVIUIxDTEs",
  },
];

function VideoHeader() {
  const [selectedVideo, setSelectedVideo] = useState(ArrayVideo[0]);
  return (
    <div className="container my-5 w-100 ">
      <iframe
        width="100%"
        height="500px"
        src={`https://www.youtube.com/embed/${selectedVideo.key}`}
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
        className="rounded-4"
      ></iframe>

      <div className="container w-100">
        <div className="row my-3">
          {ArrayVideo.map((item) => {
            return (
              <div
                className="col-6 col-sm-4 col-md-3 col-lg-3 my-2"
                onClick={() => {
                  setSelectedVideo(item);
                }}
              >
                <img
                  src={`https://i.ytimg.com/vi/${item.key}/mqdefault.jpg`}
                  alt={item.title}
                  style={{ width: "95%", height: "100%", cursor: "pointer" }}
                  className="rounded-4 "
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default VideoHeader;
